import React from 'react';

import blastoffIcon from '../../assets/images/icons/blastoff.svg';
import StatusView from '../../components/StatusView/StatusView';

function SignUpSuccess() {
  const term = 'event listing';
  const buttonText = `Go to ${term}`;
  const loadingText = `Redirecting to ${term}...`;

  return (
    <StatusView
      buttonText={buttonText}
      image={blastoffIcon}
      loadingText={loadingText}
      navigationPath="/"
      title="Sign up successful!"
    />
  );
}

export default SignUpSuccess;



// WEBPACK FOOTER //
// ./src/views/SignUpSuccess/SignUpSuccess.js